var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"value":_vm.show,"width":"800px"},on:{"input":function($event){return _vm.dialogsChangePrivacePolice($event)}}},[_c('v-card',[_c('v-card-title',{staticClass:"lighten-4 pt-2 title"}),_c('v-container',{staticClass:"pb-6 px-6"},[_c('v-row',[_c('k-privace-police-contract')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }